export const createGuest = {
    method: 'POST',
    paths: ['/api/orgs/:orgId/locations/:locationId/guests'],
    fields: {
        _id: {
            type: 'mongoId',
            required: true,
        },
    },
};
//# sourceMappingURL=create_guest_schema.js.map